import React from 'react';

import OrdersComp from '../../components/orders-comp';
import UserLayout from '../../shared/layouts/user-layout';
// style link end 

const OrdersPage = () => {

    return (

        <UserLayout>
            <OrdersComp />
        </UserLayout>
    )
}

export default OrdersPage;


